import { AssociatedDataType } from "./common";
import { NovelGroupSummary } from "./novelGroup";

export interface Novel {
  novelId: string;
  title: string;
  image?: string;
  description?: string;
  genre?: string;
  category?: string[];
  workStatus?: string;
  pinned?: boolean;
  agentStatus?: number;
  agentStartedAt?: number | string;
  agentCampaignIds?: string[];
  associatedData?: NovelAssociatedDataType;
  updatedAtLatestDataInNovel?: string;
  createdAt?: string;
  updatedAt?: string;
  groups?: NovelGroupSummary[];
  manuscriptMode?: "default" | "script";
}

/** 脚本モード（執筆フォーマット）の作品かどうか */
export function isScriptModeNovel(novel: Pick<Novel, "manuscriptMode"> | null | undefined): boolean {
  return novel?.manuscriptMode === "script";
}

export type NovelAssociatedDataType = AssociatedDataType & {
  nolaNovel: {};
};

export interface NovelSetting {
  id: string;
  name: string;
  image: string;
}

export interface ManuscriptSetting {
  novelId: string;
  wordCountOnVertical: number;
  lineCountPerPage: number;
  fontSizeRate: number;
}

export type TCopyNovelPayload = {
  novelId: string;
  copySelectedData?: string[];
};
